import React from 'react'
import logo from "../../static/logo.svg";
import {LoadingLogo, Title, LoadingContainer} from "./style"

const Loading = () => {
  return (
    <div>
      <LoadingContainer>
        <LoadingLogo className="loading" src={logo} alt="COVID"></LoadingLogo>
        <Title>Loading...</Title>
      </LoadingContainer>
    </div>
  )
}

export default Loading;
